import {
  Box,
  IconButton,
  useTheme,
  Typography,
  ListItem,
  ListItemText,
  ButtonBase,
  ListItemIcon,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext } from "../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../features/authSlice";
import { useRestaurant } from "../hooks/RestaurantContext";
import SettingsMenu from "./settingsMenu";
import CustomDialog from "../components/cutomPopUp";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
const apiUrl = process.env.REACT_APP_MEDIA_URL;
const Topbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isCompact = useMediaQuery("(max-width:900px)");
  const colorMode = useContext(ColorModeContext);
  const { restaurantName, restaurantLogo, setRestaurantId, setRestaurantName, setRestaurantLogo, setCurrency } = useRestaurant();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = (e) => {
    dispatch(logout());
    setRestaurantId("");
    setRestaurantName("");
    setRestaurantLogo("");
    setCurrency("");
    navigate("/signin");
  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" className="topbar">
      <Box display="flex" alignItems="center" gap={1} minWidth={0} flex={1}>
        {restaurantLogo ? (
          <img
            src={`${apiUrl}/${String(restaurantLogo).replace(/\\/g, "/")}`}
            alt=""
            loading="lazy"
            height={isCompact ? 32 : 40}
            style={{ borderRadius: 8, objectFit: "contain", flexShrink: 0 }}
          />
        ) : null}
        <Typography
          variant={isCompact ? "subtitle1" : "h4"}
          sx={{
            fontWeight: 700,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {restaurantName}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={0.25} flexShrink={0}>
          <LanguageSwitcher />
          <IconButton onClick={colorMode.toggleColorMode} size={isCompact ? "small" : "medium"}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlinedIcon />
            ) : (
              <LightModeOutlinedIcon />
            )}
          </IconButton>
          <SettingsMenu />
          {isCompact ? (
            <Tooltip title={t("auth.logout")}>
              <IconButton
                onClick={() => setIsOpen(true)}
                size="small"
                sx={{
                  ml: 1.5,
                  bgcolor: "error.main",
                  color: "#fff",
                  opacity: 0.9,
                  "&:hover": { bgcolor: "error.dark", opacity: 1 },
                }}
              >
                <LogoutIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : (
            <Box
              onClick={() => setIsOpen(true)}
              role="button"
              aria-label={t("auth.logout")}
              sx={{
                ml: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.75,
                borderRadius: "8px",
                cursor: "pointer",
                color: "error.main",
                bgcolor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(233,49,60,0.14)"
                    : "rgba(233,49,60,0.08)",
                "&:hover": {
                  bgcolor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(233,49,60,0.22)"
                      : "rgba(233,49,60,0.14)",
                },
              }}
            >
              <LogoutIcon fontSize="small" />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {t("auth.logout")}
              </Typography>
            </Box>
          )}
      </Box>
      <CustomDialog
        open={isOpen}
        handleClose={() => setIsOpen(false)}
        title={t("auth.logoutTitle")}
        message={t("auth.logoutConfirm")}
        cancelText={t("common.cancel")}
        confirmText={t("auth.logout")}
        onClick={handleLogout}
      />
    </Box>
  );
};

export const MenuButtonItem = ({ onClick, icon, label, colors }) => (
  <ButtonBase
    component="div"
    onClick={onClick}
    style={{ width: "100%" }}
    sx={{
      "&:hover": {
        backgroundColor: colors.primary[400],
      },
      textAlign: "center",
      alignContent: "center",
      alignItems: "center",
    }}
  >
    <ListItem>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  </ButtonBase>
);

export default Topbar;
